import _ from "lodash";
/** external */
import React, { PureComponent } from "react";
import { onEnterOrSpaceKeyDown } from "Utils/AccessibilityHelpers";
import PropTypes from "prop-types";
import { ChevronDownOutlined, ChevronUpOutlined } from "@toddle-edu/ds-icons";
import { IconButton } from "@toddle-edu/ds-web";
import classNames from "classnames";
import { customTextStyle } from "Worksheet/modules/WorksheetConstants";
import TextViewWrapper from "Worksheet/components/TextViewWrapper";

/** relative */
import classes from "./Accordion.scss";

class Accordion extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: props.showDetails,
    };

    if (props.customRef) {
      props.customRef(this);
    }
  }

  toggleAccordion = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }));
  };

  isValid = () => {
    return 0;
  };

  render() {
    const {
      disableAccordionBehaviour,
      labelComponent,
      value,
      isAiGeneratedField,
      showDocEditor,
    } = this.props;
    const { isOpen } = this.state;

    const containerClasses = classNames({
      [classes.container]: true,
      [classes.removeCursor]: disableAccordionBehaviour,
    });

    const contentStyles = {
      display: disableAccordionBehaviour || isOpen ? "flex" : "none",
    };

    return !_.isEmpty(value) ? (
      <div
        className={containerClasses}
        onClick={disableAccordionBehaviour ? null : this.toggleAccordion}
        onKeyDown={
          disableAccordionBehaviour
            ? null
            : e => onEnterOrSpaceKeyDown(e, this.toggleAccordion)
        }
        role={disableAccordionBehaviour ? undefined : "button"}
        tabIndex={disableAccordionBehaviour ? undefined : 0}
        data-test-id="worksheet-accordion-accordionItem"
      >
        <div className={classes.header}>
          {labelComponent}
          {disableAccordionBehaviour ? null : (
            <IconButton
              dsVersion="2.0"
              variant="neutral"
              type="plain"
              size="medium"
              _legacy_variant="plain"
              _legacy_size="small"
              icon={isOpen ? <ChevronUpOutlined /> : <ChevronDownOutlined />}
              testId="worksheet-accordion-accordionItem"
            />
          )}
        </div>
        <div className={classNames(classes.content)} style={contentStyles}>
          <TextViewWrapper
            value={value}
            isAiGeneratedField={isAiGeneratedField}
            customTextStyle={customTextStyle}
            mode={"view"}
            showDocEditor={showDocEditor}
          />
        </div>
      </div>
    ) : null;
  }
}

Accordion.propTypes = {
  labelComponent: PropTypes.element,
  value: PropTypes.string,
  disableAccordionBehaviour: PropTypes.bool,
  showDetails: PropTypes.bool,
  showDocEditor: PropTypes.bool,
};
Accordion.defaultProps = {
  disableAccordionBehaviour: false,
  showDetails: false,
  showDocEditor: false,
};

export default Accordion;
